// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2UaH6","rootSmall":"AddTileButton_rootSmall__2XU1i"};